import { CrmLayoutMenuConfig, CrmLayoutMenuProvider, CrmLayoutSiderControl } from '@touch4it/ng-swp/layout-v2';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CrmMenuItem } from '@touch4it/ng-swp/menu';
import { intersection } from 'lodash-es';

import { ProfilesApiService } from '~/api/profiles/profiles-api.service';
import { UsersApiService } from '~/api/users/users-api.service';

@Injectable()
export class MenuProvider extends CrmLayoutMenuProvider {
  private user = inject(UsersApiService);
  private profiles = inject(ProfilesApiService);

  override getComponentConfig(): Observable<CrmLayoutMenuConfig> {
    return this.profiles.currentWorkspaceNamespace$.pipe(map((workspace) => ({ ...this.config, prefix: workspace })));
  }

  override items$(_options: { siderControl?: CrmLayoutSiderControl }): Observable<CrmMenuItem[]> {
    return this.user.user$.pipe(
      map((user) => {
        const userRoles = Object.entries(user.roles ?? {})
          .filter(([_, v]) => v)
          .map(([k]) => k);

        return (this.config.items ?? []).filter((item) => !item.role || intersection(userRoles, item.role).length);
      }),
      catchError(() => of([])),
    );
  }
}
